<template>
  <section class="scala-predi-action-module-component">
    <div class="inner-container">
      <div class="content">
        <h2
          class="content-title"
          v-html="data.left.title" />
        <div
          class="content-text"
          v-html="data.left.text" />
      </div>
      <div class="svg-container">
        <svg
          class="svg"
          width="100%"
          height="100%"
          viewBox="0 0 485 484"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M91.1712 141.226L90.7836 141.835C86.6862 147.981 82.9763 154.349 79.7095 160.993L79.3219 161.768"
            stroke="#FFAD39"
            stroke-width="7"
            stroke-miterlimit="10" />
          <path
            d="M230.76 423.393H231.203C234.857 423.615 238.567 423.726 242.277 423.726C245.987 423.726 249.696 423.615 253.351 423.393H253.738"
            stroke="#FFAD39"
            stroke-width="7"
            stroke-miterlimit="10" />
          <path
            d="M405.232 161.602L404.955 161.049C401.633 154.404 397.923 148.036 393.881 141.89L393.604 141.392"
            stroke="#FFAD39"
            stroke-width="7"
            stroke-miterlimit="10" />

          <path
            ref="scalability"
            d="M446.151 111.658L340.393 172.732C318.633 142.001 282.808 122.012 242.332 122.012C201.856 122.012 166.032 142.056 144.271 172.732L38.5139 111.658C81.5367 44.6046 156.73 0.142212 242.332 0.142212C327.935 0.142212 403.128 44.6046 446.151 111.658Z"
            fill="url(#paint3_linear_18_117)"
            @mouseenter="mouseIn(0)"
            @mouseleave="mouseOut()" />
          <path
            ref="predictability"
            d="M484.301 242.111C484.301 372.01 381.921 478.044 253.406 483.802V361.766C314.591 356.174 362.486 304.735 362.486 242.111C362.486 224.171 358.555 207.172 351.523 191.89L457.28 130.872C474.5 164.149 484.301 202.023 484.301 242.111Z"
            fill="url(#paint4_linear_18_117)"
            @mouseenter="mouseIn(1)"
            @mouseleave="mouseOut()" />
          <path
            ref="actionability"
            d="M231.258 361.766V483.858C102.744 478.099 0.36377 372.065 0.36377 242.166C0.36377 202.023 10.109 164.205 27.4399 130.872L133.197 191.89C126.165 207.172 122.234 224.171 122.234 242.111C122.179 304.735 170.074 356.174 231.258 361.766Z"
            fill="url(#paint5_linear_18_117)"
            @mouseenter="mouseIn(2)"
            @mouseleave="mouseOut()" />
          <path
            d="M173.008 85.634C177.66 83.5853 178.379 81.3152 177.217 78.7127C176.165 76.3318 174.393 75.7227 171.292 76.4979L165.589 78.0483C161.436 79.2111 158.778 78.1037 157.283 74.6707C155.678 71.0716 157.117 66.9742 162.931 64.3718C168.856 61.714 173.119 63.4305 175.334 67.5833L172.566 68.8014C170.904 65.8668 168.136 64.6487 163.872 66.5313C159.886 68.3031 158.944 70.7948 160.052 73.2864C160.827 75.0583 162.267 76.055 165.035 75.3352L171.015 73.674C175.279 72.5113 178.213 73.3418 179.819 76.9963C181.757 81.3152 180.262 84.9142 173.95 87.7381C166.641 91.005 162.433 88.3472 160.439 83.9176L163.208 82.6994C164.869 86.1877 167.804 87.9596 173.008 85.634Z"
            fill="black" />
          <path
            d="M187.626 61.7694C192.942 60.1637 196.486 62.2678 198.036 66.3098L195.378 67.1403C194.049 64.3718 191.724 63.0429 188.457 64.0396C184.692 65.2024 182.975 67.9155 184.526 73.0096C186.076 78.1591 188.955 79.4326 192.72 78.3252C196.319 77.2177 197.538 74.6707 196.984 71.5146L199.697 70.6841C200.749 74.8368 198.866 78.9896 193.44 80.5953C187.626 82.3672 183.363 79.2665 181.702 73.8402C180.041 68.4139 181.868 63.5413 187.626 61.7694Z"
            fill="black" />
          <path
            d="M202.521 72.3452C201.967 69.4105 203.185 67.2511 207.061 65.8668L211.546 64.2611C213.373 63.5966 214.093 62.9322 213.816 61.5479C213.484 59.6653 212.321 58.4472 208.722 59.1116C205.179 59.7761 204.127 61.714 204.403 64.095L201.469 64.6487C200.86 60.7727 203.185 57.7828 208.224 56.8415C213.207 55.9002 215.865 57.8381 216.474 61.105L218.08 69.8535C218.301 71.1824 218.634 72.5666 219.132 74.3385L216.53 74.7815C216.087 73.2311 215.754 71.9022 215.478 70.5733C215.201 72.8989 213.706 75.7781 209.498 76.5533C206.009 77.1624 203.13 75.8335 202.521 72.3452ZM209.608 74.117C213.927 73.3418 215.311 69.5766 214.647 66.1437L214.37 64.5933C213.595 65.4239 212.654 65.8668 211.325 66.4205L208.39 67.5833C206.009 68.5246 205.068 69.6874 205.4 71.6807C205.843 73.7848 207.504 74.5046 209.608 74.117Z"
            fill="black" />
          <path
            d="M220.461 48.093L223.396 47.7607L226.053 73.6187L223.119 73.9509L220.461 48.093Z"
            fill="black" />
          <path
            d="M229.542 68.2478C229.486 65.2578 231.037 63.3198 235.023 62.5446L239.73 61.6587C241.668 61.2711 242.443 60.7174 242.443 59.3332C242.388 57.4506 241.446 56.0109 237.792 56.1217C234.193 56.2324 232.864 57.9489 232.753 60.3852L229.763 60.4406C229.763 56.5093 232.532 53.9069 237.626 53.7961C242.72 53.6854 245.045 55.9556 245.101 59.2778L245.322 68.137C245.378 69.4659 245.488 70.9056 245.654 72.7328L242.997 72.7881C242.775 71.1824 242.664 69.8535 242.609 68.4693C241.945 70.7394 240.062 73.3419 235.743 73.4526C232.255 73.5633 229.652 71.7915 229.542 68.2478ZM236.297 71.127C240.727 71.0163 242.609 67.528 242.554 64.0396L242.498 62.4339C241.612 63.0983 240.616 63.4306 239.176 63.7628L236.131 64.4826C233.639 65.0917 232.476 66.033 232.532 68.0817C232.587 70.1857 234.137 71.1824 236.297 71.127Z"
            fill="black" />
          <path
            d="M268.467 65.2578C267.969 70.9055 264.923 74.8368 259.109 74.3385C255.732 74.0063 253.517 72.3452 252.52 69.632L252.188 73.1203L249.254 72.8435L251.634 46.9855L254.569 47.2624L253.572 58.115C255.067 55.6787 257.504 54.4052 260.937 54.7374C266.695 55.1803 268.965 59.5546 268.467 65.2578ZM258.722 71.8468C262.875 72.2344 264.979 69.9089 265.422 64.9809C265.865 59.9976 264.259 57.3952 260.051 57.0076C256.119 56.6753 253.462 58.6687 252.963 63.8735C252.576 69.0783 254.846 71.5146 258.722 71.8468Z"
            fill="black" />
          <path
            d="M273.893 57.0076L276.828 57.5059L273.561 75.7781L270.626 75.2798L273.893 57.0076ZM274.558 50.9168L278.323 51.5813L277.769 54.6266L274.004 53.9622L274.558 50.9168Z"
            fill="black" />
          <path
            d="M284.081 51.4152L286.961 52.0796L281.202 77.3839L278.323 76.7194L284.081 51.4152Z"
            fill="black" />
          <path
            d="M290.892 60.7174L293.771 61.4926L288.843 79.3772L285.964 78.602L290.892 60.7174ZM292.11 54.682L295.82 55.6787L294.989 58.6687L291.28 57.672L292.11 54.682Z"
            fill="black" />
          <path
            d="M295.765 76.9409L299.64 65.7007L296.263 64.538L296.817 62.9876L300.748 63.3752L303.073 60.1083L304.568 60.6067L303.24 64.4826L308.998 66.4759L308.223 68.6907L302.409 66.6974L297.924 79.7648L303.461 81.6474L302.686 83.9176L298.533 82.478C295.266 81.3152 294.823 79.7094 295.765 76.9409Z"
            fill="black" />
          <path
            d="M302.797 89.1778L307.503 91.3372L311.435 87.6274L310.493 87.1844L311.49 67.2511L314.314 68.5246L313.594 83.8622L313.428 85.7448L314.646 84.3605L325.775 73.7294L328.433 74.9476L311.545 91.005C309.275 93.2198 308.002 94.1611 305.012 92.7768L301.8 91.3926L302.797 89.1778Z"
            fill="black" />
          <path
            d="M429.318 245.931C425.387 246.042 422.009 244.049 421.843 238.567L421.566 230.538L411.323 230.871L411.212 227.77L435.852 226.939L436.239 238.235C436.461 243.495 433.305 245.765 429.318 245.931ZM424.279 237.847C424.39 241.502 426.383 242.775 429.207 242.664C432.142 242.554 433.858 241.169 433.748 237.626L433.471 230.095L424.002 230.428L424.279 237.847Z"
            fill="black" />
          <path
            d="M430.038 250.748L429.816 253.683L424.888 253.351C427.934 254.68 429.872 256.95 429.595 260.494L429.539 261.158L426.605 260.937L426.66 260.106C427.214 254.624 423.283 253.24 418.078 252.853L411.267 252.41L411.489 249.475L430.038 250.748Z"
            fill="black" />
          <path
            d="M420.016 262.265C425.497 263.151 429.207 266.861 428.21 272.952C427.325 278.434 423.061 280.925 417.69 280.095C417.192 280.039 416.86 279.984 416.417 279.818L418.798 265.089C413.759 264.48 411.544 266.584 410.935 270.294C410.326 273.893 411.765 275.831 413.98 276.717L413.537 279.375C410.824 278.544 407.723 275.887 408.72 269.796C409.828 263.484 414.479 261.38 420.016 262.265ZM419.13 277.382C423.338 277.935 425.497 276.053 426.051 272.62C426.605 269.131 425.331 266.584 421.068 265.477L419.13 277.382Z"
            fill="black" />
          <path
            d="M417.746 299.142L428.266 302.188L427.435 305.011L402.519 297.758L403.349 294.934L406.782 295.931C404.623 293.993 403.792 291.335 404.733 288.013C406.339 282.42 411.156 281.036 416.583 282.642C422.064 284.248 425.331 287.957 423.67 293.55C422.673 296.817 420.625 298.644 417.746 299.142ZM406.838 289.286C405.73 293.051 407.17 296.097 412.208 297.536C417.247 298.976 420.071 297.26 421.178 293.439C422.341 289.397 420.514 286.905 415.752 285.521C410.935 284.137 408.056 285.189 406.838 289.286Z"
            fill="black" />
          <path
            d="M418.078 308.555L417.026 311.324L399.75 304.624L400.802 301.855L418.078 308.555ZM423.947 310.327L422.563 313.871L419.684 312.763L421.068 309.22L423.947 310.327Z"
            fill="black" />
          <path
            d="M411.932 324.225C409.495 329.264 405.509 330.426 401.522 328.821L402.74 326.329C405.675 327.27 408.222 326.44 409.717 323.284C411.433 319.74 410.603 316.639 405.786 314.314C400.968 311.988 398.034 313.206 396.373 316.695C394.767 320.072 395.819 322.73 398.477 324.446L397.259 326.993C393.493 324.945 391.721 320.737 394.213 315.698C396.871 310.216 402.02 309.164 407.114 311.656C412.209 314.037 414.534 318.799 411.932 324.225Z"
            fill="black" />
          <path
            d="M392.441 329.485L402.574 335.631L404.401 332.586L405.841 333.472L404.678 337.237L407.391 340.172L406.561 341.556L403.017 339.396L399.861 344.657L397.868 343.438L401.024 338.178L389.23 331.036L386.184 336.074L384.136 334.801L386.406 331.036C388.233 328.046 389.894 327.935 392.441 329.485Z"
            fill="black" />
          <path
            d="M387.236 339.175C389.673 340.947 390.226 343.383 388.344 347.038L386.184 351.301C385.298 353.073 385.243 354.014 386.351 354.845C387.901 355.952 389.562 356.063 391.721 353.184C393.881 350.304 393.272 348.145 391.445 346.595L393.216 344.214C396.317 346.65 396.649 350.415 393.604 354.513C390.614 358.61 387.347 359.053 384.689 357.06L377.547 351.799C376.495 351.024 375.276 350.194 373.726 349.252L375.332 347.093C376.716 347.868 377.879 348.643 378.986 349.474C377.602 347.591 376.716 344.435 379.263 341.002C381.367 338.068 384.413 337.071 387.236 339.175ZM380.813 342.774C378.211 346.318 379.761 349.972 382.585 352.076L383.859 353.018C383.859 351.855 384.246 350.913 384.8 349.585L386.129 346.705C387.236 344.38 387.126 342.885 385.52 341.667C383.859 340.393 382.087 341.002 380.813 342.774Z"
            fill="black" />
          <path
            d="M365.697 371.733C361.545 367.857 360.326 363.04 364.313 358.776C366.639 356.284 369.352 355.62 372.065 356.451L369.518 354.07L371.567 351.91L390.503 369.684L388.455 371.843L380.537 364.424C381.533 367.082 381.035 369.795 378.709 372.286C374.667 376.55 369.85 375.664 365.697 371.733ZM366.473 359.994C363.593 363.04 364.147 366.085 367.746 369.518C371.401 372.951 374.446 373.283 377.325 370.238C380.038 367.358 380.094 364.036 376.273 360.437C372.453 356.838 369.13 357.17 366.473 359.994Z"
            fill="black" />
          <path
            d="M368.798 381.09L366.583 383.084L354.18 369.296L356.395 367.303L368.798 381.09ZM373.228 385.354L370.404 387.901L368.355 385.631L371.179 383.084L373.228 385.354Z"
            fill="black" />
          <path
            d="M366.915 392.607L364.59 394.49L348.2 374.335L350.526 372.453L366.915 392.607Z"
            fill="black" />
          <path
            d="M355.399 392.22L353.018 393.992L341.999 379.097L344.38 377.325L355.399 392.22ZM359.385 396.871L356.34 399.141L354.513 396.649L357.558 394.379L359.385 396.871Z"
            fill="black" />
          <path
            d="M339.673 386.074L346.152 396.04L349.142 394.102L350.028 395.487L347.314 398.366L348.477 402.186L347.148 403.072L344.934 399.639L339.784 402.962L338.511 401.024L343.66 397.701L336.13 386.074L331.202 389.285L329.873 387.236L333.527 384.856C336.517 382.918 338.012 383.582 339.673 386.074Z"
            fill="black" />
          <path
            d="M325.665 384.025L321.069 386.406L321.567 391.777L322.508 391.278L337.625 404.346L334.856 405.786L323.228 395.763L321.844 394.49L322.176 396.317L323.671 411.655L321.069 412.984L318.799 389.783C318.466 386.627 318.466 385.077 321.456 383.527L324.557 381.921L325.665 384.025Z"
            fill="black" />
          <path
            d="M150.473 384.8L149.421 391.445L159.997 397.535L165.201 393.272L167.914 394.822L147.483 411.544L143.552 409.274L147.704 383.25L150.473 384.8ZM148.978 394.047L146.652 408.443L157.948 399.197L148.978 394.047Z"
            fill="black" />
          <path
            d="M128.38 392.386C123.95 389.008 123.563 384.911 125.944 381.312L128.158 382.973C126.663 385.686 126.996 388.344 129.764 390.393C132.92 392.774 136.132 392.552 139.343 388.289C142.61 383.97 141.946 380.924 138.845 378.543C135.855 376.273 133.031 376.827 130.816 379.097L128.546 377.381C131.315 374.114 135.744 373.172 140.229 376.605C145.102 380.26 145.102 385.52 141.669 390.06C138.291 394.656 133.142 396.04 128.38 392.386Z"
            fill="black" />
          <path
            d="M127.051 372.231L119.022 380.98L121.625 383.416L120.517 384.634L117.084 382.751L113.651 384.856L112.489 383.748L115.257 380.703L110.772 376.55L112.378 374.833L116.863 378.986L126.221 368.853L121.902 364.867L123.507 363.095L126.719 366.085C129.321 368.411 129.044 370.072 127.051 372.231Z"
            fill="black" />
          <path
            d="M103.685 377.99L101.027 375.221L103.242 373.062L105.9 375.83L103.685 377.99ZM107.782 373.449L105.733 371.29L119.133 358.444L121.182 360.603L107.782 373.449Z"
            fill="black" />
          <path
            d="M109.609 362.264C105.346 365.753 100.03 366.085 96.0991 361.212C92.1678 356.395 93.6074 351.246 97.8709 347.813C102.19 344.324 107.505 343.937 111.437 348.809C115.368 353.627 113.928 358.721 109.609 362.264ZM109.554 350.249C106.896 346.982 103.796 346.761 99.8089 350.083C95.7669 353.405 95.3793 356.451 97.9817 359.662C100.639 362.929 103.685 363.206 107.782 359.884C111.769 356.617 112.156 353.516 109.554 350.249Z"
            fill="black" />
          <path
            d="M87.7381 349.419L86.1323 346.927L90.2297 344.324C86.7414 345.155 83.8068 344.325 81.8134 341.224C79.3218 337.292 80.4292 334.247 84.4712 331.7L94.4933 325.388L96.099 327.879L86.4092 334.026C83.0316 336.13 82.9762 338.234 84.4158 340.559C86.6307 344.048 90.4512 344.214 95.8775 340.781L101.858 337.016L103.463 339.507L87.7381 349.419Z"
            fill="black" />
          <path
            d="M88.7902 325.111C86.077 326.44 83.6961 325.775 81.3152 322.453L78.5467 318.522C77.3839 316.916 76.6087 316.418 75.3352 317.027C73.6187 317.857 72.7328 319.297 74.2831 322.564C75.8335 325.831 77.993 326.274 80.2078 325.443L81.4813 328.101C77.8822 329.707 74.3939 328.267 72.1791 323.671C69.9643 319.076 71.0717 316.03 74.117 314.591L82.1457 310.715C83.3639 310.161 84.6374 309.441 86.1878 308.5L87.3506 310.881C86.0217 311.767 84.8035 312.431 83.53 312.985C85.8555 312.653 89.0117 313.317 90.8943 317.193C92.5554 320.46 92.0017 323.616 88.7902 325.111ZM88.6794 317.802C86.7415 313.815 82.8102 313.483 79.6541 315.034L78.2144 315.753C79.2111 316.307 79.9309 317.082 80.8168 318.19L82.6994 320.681C84.2498 322.73 85.6341 323.339 87.4613 322.453C89.2885 321.567 89.5654 319.74 88.6794 317.802Z"
            fill="black" />
          <path
            d="M70.075 290.837C75.4459 289.009 80.2631 290.172 82.2011 295.654C83.3085 298.865 82.644 301.579 80.6507 303.627L83.9729 302.464L84.9142 305.288L60.3851 313.76L59.4438 310.936L69.7427 307.392C66.9188 307.06 64.7594 305.288 63.652 302.077C61.6033 296.595 64.704 292.719 70.075 290.837ZM80.097 297.038C78.7127 293.051 75.7781 292.11 71.0716 293.771C66.3098 295.377 64.6487 297.979 65.9776 301.911C67.2511 305.621 70.1857 307.226 75.1137 305.565C80.0416 303.904 81.3705 300.748 80.097 297.038Z"
            fill="black" />
          <path
            d="M54.5159 291.224L53.5746 287.514L56.5646 286.739L57.5059 290.449L54.5159 291.224ZM60.3298 289.286L59.61 286.407L77.6053 281.867L78.3251 284.746L60.3298 289.286Z"
            fill="black" />
          <path
            d="M51.0829 282.254L50.4739 279.32L75.9442 274.17L76.5533 277.105L51.0829 282.254Z"
            fill="black" />
          <path
            d="M50.7507 273.617L50.197 269.851L53.2424 269.408L53.7961 273.174L50.7507 273.617ZM56.7307 272.232L56.2878 269.298L74.6154 266.474L75.0583 269.408L56.7307 272.232Z"
            fill="black" />
          <path
            d="M69.5767 261.158L57.7274 262.21L58.0596 265.754L56.3985 265.92L55.125 262.21L51.1937 261.435L51.0276 259.829L55.125 259.442L54.5713 253.351L56.8968 253.129L57.4505 259.22L71.1824 258.002L70.6287 252.188L73.0096 251.967L73.3972 256.341C73.7848 259.829 72.5113 260.881 69.5767 261.158Z"
            fill="black" />
          <path
            d="M77.8822 249.697V244.547L72.8989 242.498V243.55L54.2944 250.804V247.703L68.58 242.111L70.3518 241.502L68.58 240.948L54.3498 235.134V232.199L75.9443 241.003C78.8789 242.166 80.2631 242.941 80.2631 246.264V249.807L77.8822 249.697Z"
            fill="black" />
          <defs>
            <linearGradient
              id="paint0_linear_18_117"
              x1="38.4868"
              y1="86.4369"
              x2="446.135"
              y2="86.4369"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0.1916"
                stop-color="#91CDD5" />
              <stop
                offset="0.398"
                stop-color="#ACC2A9" />
              <stop
                offset="0.6769"
                stop-color="#CDB573" />
              <stop
                offset="0.8861"
                stop-color="#E2AD52" />
              <stop
                offset="1"
                stop-color="#EAAA45" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_18_117"
              x1="275.265"
              y1="496.474"
              x2="479.079"
              y2="143.459"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFAD39" />
              <stop
                offset="0.1857"
                stop-color="#E9B251" />
              <stop
                offset="0.5783"
                stop-color="#B1BF8F" />
              <stop
                offset="1"
                stop-color="#6FCFD7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_18_117"
              x1="209.356"
              y1="496.474"
              x2="5.54279"
              y2="143.459"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FCFD7" />
              <stop
                offset="0.4217"
                stop-color="#B1BF8F" />
              <stop
                offset="0.8143"
                stop-color="#E9B251" />
              <stop
                offset="1"
                stop-color="#FFAD39" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_18_117"
              x1="38.4868"
              y1="86.4369"
              x2="446.135"
              y2="86.4369"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FCFD7" />
              <stop
                offset="0.2147"
                stop-color="#8FC8B4" />
              <stop
                offset="0.9995"
                stop-color="#FFAD39" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_18_117"
              x1="479.079"
              y1="143.459"
              x2="275.265"
              y2="496.474"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FCFD7" />
              <stop
                offset="0.4217"
                stop-color="#B1BF8F" />
              <stop
                offset="0.8143"
                stop-color="#E9B251" />
              <stop
                offset="1"
                stop-color="#FFAD39" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_18_117"
              x1="209.356"
              y1="496.474"
              x2="5.54289"
              y2="143.459"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#6FCFD7" />
              <stop
                offset="0.4217"
                stop-color="#B1BF8F" />
              <stop
                offset="0.8143"
                stop-color="#E9B251" />
              <stop
                offset="1"
                stop-color="#FFAD39" />
            </linearGradient>
          </defs>
        </svg>
        <div class="title">
          <span
            class="title-inner"
            v-html="data.right.title" />
        </div>
        <div
          v-for="(section, idx) of data.right.sections"
          :key="`idx-${idx}`"
          class="inner-text-container"
          :class="{ active: idx === active }">
          <div class="section">
            <div
              v-if="idx === 0"
              class="section-title">
              Scalability
            </div>
            <div
              v-if="idx === 1"
              class="section-title">
              Predictability
            </div>
            <div
              v-if="idx === 2"
              class="section-title">
              Actionability
            </div>
            <div
              class="section-content"
              v-html="section.Text" />
          </div>
        </div>
        <svg
          class="mobile-btns"
          width="100%"
          height="100%"
          viewBox="0 0 386 356"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g
            class="btn-scalability"
            :class="mobileBtnsClasses(0)"
            @click="select(0)">
            <g filter="url(#filter1_d_20_8)">
              <ellipse
                cx="194.951"
                cy="44"
                rx="22"
                ry="22"
                transform="rotate(-180 194.951 44)"
                fill="#6FCFD7" />
            </g>
            <line
              class="animated-line"
              x1="194.951"
              y1="34"
              x2="194.951"
              y2="54"
              stroke="white"
              stroke-width="2" />
            <path
              d="M184.951 44H204.951"
              stroke="white"
              stroke-width="2" />
          </g>
          <g
            class="btn-actionability"
            :class="mobileBtnsClasses(2)"
            @click="select(2)">
            <g filter="url(#filter3_d_20_8)">
              <ellipse
                cx="33"
                cy="319.608"
                rx="22"
                ry="22"
                transform="rotate(-180 33 319.608)"
                fill="#6FCFD7" />
            </g>
            <line
              class="animated-line"
              x1="33"
              y1="309.608"
              x2="33"
              y2="329.608"
              stroke="white"
              stroke-width="2" />
            <path
              d="M23 319.608H43"
              stroke="white"
              stroke-width="2" />
          </g>
          <g
            class="btn-predictability"
            :class="mobileBtnsClasses(1)"
            @click="select(1)">
            <g filter="url(#filter5_d_20_8)">
              <ellipse
                cx="352.658"
                cy="322.057"
                rx="22"
                ry="22"
                transform="rotate(-180 352.658 322.057)"
                fill="#6FCFD7" />
            </g>
            <line
              class="animated-line"
              x1="352.658"
              y1="312.057"
              x2="352.658"
              y2="332.057"
              stroke="white"
              stroke-width="2" />
            <path
              d="M342.658 322.057H362.658"
              stroke="white"
              stroke-width="2" />
          </g>
          <defs>
            <filter
              id="filter1_d_20_8"
              x="166.951"
              y="18"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="3" />
              <feComposite
                in2="hardAlpha"
                operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.32549 0 0 0 0 0.388235 0 0 0 0 0.392157 0 0 0 0.6 0" />
              <feBlend
                mode="multiply"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_20_8" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_20_8"
                result="shape" />
            </filter>
            <filter
              id="filter3_d_20_8"
              x="5"
              y="293.608"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="3" />
              <feComposite
                in2="hardAlpha"
                operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.32549 0 0 0 0 0.388235 0 0 0 0 0.392157 0 0 0 0.6 0" />
              <feBlend
                mode="multiply"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_20_8" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_20_8"
                result="shape" />
            </filter>
            <filter
              id="filter5_d_20_8"
              x="324.658"
              y="296.057"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="3" />
              <feComposite
                in2="hardAlpha"
                operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.32549 0 0 0 0 0.388235 0 0 0 0 0.392157 0 0 0 0.6 0" />
              <feBlend
                mode="multiply"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_20_8" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_20_8"
                result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ScalaPrediActionComponent",
  "CLASSNAME": "scala-predi-action-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */
import { ref } from 'vue'
import useUtils from '@/composables/useUtils'
const { device } = useUtils()

const scalability = ref()
const predictability = ref()
const actionability = ref()

const active = ref(-1)

const select = (idx) => {
  if (active.value === -1) {
    active.value = idx
  } else {
    active.value = -1
  }
}

const mouseIn = (hover) => {
  if (device.value === 'desktop') {
    active.value = hover
  }
}

const mouseOut = () => {
  active.value = -1
}

const mobileBtnsClasses = (idx) => {
  const classes = []
  if (idx === active.value) {
    classes.push('active')
  }
  if (idx !== active.value && active.value !== -1) {
    classes.push('not-active')
  }

  return classes
}

defineProps(['data'])
</script>

<style lang="scss">
.scala-predi-action-module-component {
  @apply bg-[url('@/assets/img/scala-predi-action-bg.jpg')] bg-cover bg-no-repeat py-[60px] lg:py-[70px];

  .inner-container {
    @apply flex flex-col gap-[47px] lg:flex-row items-center lg:gap-0 lg:justify-between;

    .content {
      @apply flex flex-col gap-[30px] pl-[22px] pr-[63px] lg:p-0 lg:max-w-[510px];

      &-title {
        @apply heading-2;
        sup {
          @apply text-inherit text-lg -top-6 lg:-top-8 font-nuances font-bold;
        }
      }

      &-text {
        p {
          @apply medium lg:large;
          sup {
            @apply text-inherit text-xs -top-2.5;
          }
        }
      }
    }

    .svg-container {
      @apply relative w-full max-w-[516px] lg:h-[516px];

      .svg {
        path[fill='black'] {
          @apply pointer-events-none;
        }
      }

      .mobile-btns {
        @apply absolute top-0 left-0 pointer-events-none translate-y-[-12%] scale-[1.07] lg:hidden;

        .btn-scalability,
        .btn-actionability,
        .btn-predictability {
          @apply pointer-events-auto;

          .animated-line {
            @apply transition-all;
          }
        }

        .btn-scalability {
          .animated-line {
            @apply origin-[195px_44px];
          }
        }

        .btn-actionability {
          .animated-line {
            @apply origin-[33px_319.5px];
          }
        }

        .btn-predictability {
          .animated-line {
            @apply origin-[352.5px_322px];
          }
        }

        .active {
          .animated-line {
            @apply rotate-90;
          }
        }

        .not-active {
          @apply pointer-events-none opacity-0;
        }
      }

      .title {
        @apply absolute top-0 w-full h-full flex justify-center items-center pointer-events-none;

        &-inner {
          @apply font-nuances text-[28px] not-italic font-normal leading-10 tracking-[-0.28px];
          sup {
            @apply text-inherit text-xs -top-4 font-nuances;
          }
        }
      }

      .inner-text-container {
        @apply opacity-0 absolute top-0 w-full h-full rounded-full p-[5px] transition-all lg:pointer-events-none;
        background: linear-gradient(
          90deg,
          #6fcfd7 -0.01%,
          #8fc8b4 21.46%,
          #ffad39 99.95%
        );

        &.active {
          @apply opacity-100;
        }

        .section {
          @apply h-full w-full bg-yellow-500 rounded-full flex items-center justify-center;
          background: linear-gradient(
              0deg,
              rgba(243, 240, 237, 0.5) 0%,
              rgba(243, 240, 237, 0.5) 100%
            ),
            linear-gradient(180deg, #ffad39 0%, #6fcfd7 100%);

          &-title {
            @apply absolute top-[50px] sm:top-[76px] text-center text-[34px] not-italic font-normal leading-[38px] tracking-[0.34px] lg:text-4xl lg:leading-[42px];
          }

          &-content {
            @apply max-w-[270px] sm:max-w-[450px] relative top-[15px] max-h-[220px] overflow-y-auto flex flex-col gap-3 lg:mt-[30px] lg:overflow-hidden lg:max-h-none lg:max-w-[85%];

            p {
              @apply text-[15px] leading-tight sm:text-[18px] sm:leading-[22px] text-center lg:large;
            }
          }
        }
      }
    }
  }
}
</style>
